export const USER = "user";
export const AUTHORIZATION = "Authorization";
export const PERMISSIONS = "permissions";
export const SIDEBAR = "sidebar";
export const OPEN_GANT_IDS = "openGantIds";
